import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "cameraFilled"
const CameraFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 2.25C15 2.25 15.75 3 15.75 3L17.25 5.25H21C21.828 5.25 22.5 5.922 22.5 6.75V18.75C22.5 19.578 21.828 20.25 21 20.25H3C2.172 20.25 1.5 19.578 1.5 18.75V6.75C1.5 5.922 2.172 5.25 3 5.25H6.75L8.25 3S9 2.25 12 2.25M12 8.25C9.515 8.25 7.5 10.265 7.5 12.75S9.515 17.25 12 17.25 16.5 15.235 16.5 12.75 14.485 8.25 12 8.25M5.625 8.25C5.004 8.25 4.5 8.754 4.5 9.375S5.004 10.5 5.625 10.5 6.75 9.996 6.75 9.375 6.246 8.25 5.625 8.25"
            clipRule="evenodd"
          />
          <path d="M21.75 2.25C21.75 3.078 21.078 3.75 20.25 3.75H18V2.25z" />
        </svg>
      }
    </span>
  )
}
export default CameraFilledIcon
